import type { RoleScope } from '../../../services/roles';

// Split out of TeamScopeTag.tsx for the same reason access/primitives/scopeColor.ts
// is split from ScopeTag.tsx: mixing a component export with plain-value
// exports in one file breaks fast refresh.

export const TEAM_SCOPE_LABEL: Record<RoleScope, string> = { odo: 'ODO', practice: 'Practice' };

// Solid, saturated pairs for SolidStatusPill's `toneClassName` - green for
// ODO (platform-wide), blue for Practice, the same tone convention
// events/eventStatus.ts uses.
export const TEAM_SCOPE_TONE: Record<RoleScope, string> = {
    odo: 'text-white bg-emerald-600',
    practice: 'text-white bg-blue-600'
};
